module.exports = __webpack_public_path__ + "static/assets/48366697aa58756d9140e57957188c09.png";